import KanBoIcon from 'components/KanBoIcon'
import { ListItem } from 'components/List'
import React from 'react'
import Document from 'components/Document'

type DocumentTemplateType = 'source' | 'folder' | 'template'

type Props = React.ComponentProps<typeof ListItem> & {
  type: DocumentTemplateType;
  documentTemplateSourceId: number;
  identifier?: string;
  name: string;
  url?: string;
  extension?: string;
}

const DocumentTemplateItem: React.FC<Props> = ({
  type,
  documentTemplateSourceId,
  identifier,
  name,
  url,
  extension,
  ...props
}) => {
  switch (type) {
    case 'source':
      return (
        <ListItem
          borderedIcon
          icon={
            <KanBoIcon
              fixedWidth
              name='kanbo-16-document-template-source'
            />
          }
          subtitle={url}
          {...props}
        >
          {name}
        </ListItem>
      )
    case 'folder':
      return (
        <Document
          objectType={1}
          listItem
          name={name}
          subtitle={url}
          {...props}
        />
      )
    case 'template':
      return (
        <Document
          listItem
          name={name}
          subtitle={url}
          {...props}
        />
      )
    default:
      return null
  }
}

export default DocumentTemplateItem
